export default "__VITE_ASSET__CSvY3vmc__"